module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_8017.1f6e7893.png";